module.exports = __webpack_public_path__ + "static/media/coins.53399d41.png";